import { useState, useCallback } from 'react';
import XIcon from '@/assets/common/x.svg?react';
import styles from './TagInput.module.scss';

interface TagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  maxTags?: number;
}

export function TagInput({ value, onChange, placeholder = 'Add a tag...', maxTags = 10 }: TagInputProps) {
  const [input, setInput] = useState('');

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag();
    } else if (e.key === 'Backspace' && !input && value.length > 0) {
      removeTag(value.length - 1);
    }
  }, [input, value]);

  const addTag = () => {
    const tag = input.trim().toLowerCase();
    if (tag && !value.includes(tag) && value.length < maxTags) {
      onChange([...value, tag]);
      setInput('');
    }
  };

  const removeTag = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div className={styles.tagInput}>
      <div className={styles.tagInput__tags}>
        {value.map((tag, index) => (
          <span key={tag} className={styles.tagInput__tag}>
            {tag}
            <button
              type="button"
              onClick={() => removeTag(index)}
              className={styles.tagInput__tagRemove}
            >
              <XIcon />
            </button>
          </span>
        ))}
      </div>
      {value.length < maxTags && (
        <input
          type="text"
          className={styles.tagInput__input}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={addTag}
          placeholder={value.length === 0 ? placeholder : ''}
        />
      )}
      {value.length >= maxTags && (
        <span className={styles.tagInput__limit}>Max {maxTags} tags</span>
      )}
    </div>
  );
}
